import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Snackbar,
  Alert,
  CircularProgress,Container,TablePagination,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/GetApp";
import DescriptionIcon from "@mui/icons-material/Description";
import InfoIcon from "@mui/icons-material/Info";


const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const OnboardingListPage = () => {
  const [onboardingRequests, setOnboardingRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editedRequest, setEditedRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [viewDocumentDialogOpen, setViewDocumentDialogOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isCustomProcess, setIsCustomProcess] = useState(false);
  const [customProcessName, setCustomProcessName] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });


  const [documentOptions, setDocumentOptions] = useState([
    { value: "aadhar", label: "Aadhaar Card" },
    { value: "pan", label: "PAN Card" },
    { value: "payslip", label: "Last Payslip" },
    { value: "form16", label: "Previous Employer Form 16" },
    { value: "relieving", label: "Relieving Letter" },
    { value: "education", label: "Educational Certificates" },
    { value: "bank", label: "Bank Account Details" },
    { value: "emergency", label: "Emergency Contact Information" },
  ]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload.company_id) {
        axios.get(`${API_BASE_URL}/api/cmp/${payload.company_id}`, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
          if (res.data && res.data.data) {
            const country = res.data.data.country || "";
            const nationalIdLabel = res.data.data.nationalIdLabel || "PAN Card";
            
            setDocumentOptions(prev => {
              const newOptions = [...prev];
              const panIndex = newOptions.findIndex(o => o.value === "pan");
              if (panIndex !== -1) {
                newOptions[panIndex].label = nationalIdLabel;
              }
              if (country && country.toLowerCase() !== "india") {
                return newOptions.filter(o => o.value !== "aadhar");
              }
              return newOptions;
            });
          }
        }).catch(err =>
          { 
            // console.error("Error fetching company config:", err)
      });
      }
    } catch (e) {
      // console.error(e);
    }
  }, []);

 
  const processOptions = [
    { value: "document-verification", label: "Document Verification" },
    { value: "training", label: "Mandatory Training" },
    { value: "induction", label: "Induction Meetings" },
    { value: "it-setup", label: "IT Setup" },
    { value: "complete-onboarding", label: "Complete Onboarding Process" },
  ];


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  // 4. Add this function to get paginated data
  const getPaginatedRequests = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return onboardingRequests.slice(startIndex, endIndex);
  };

  // Function to calculate onboarding status based on documents
  const calculateOnboardingStatus = (request) => {
    const requiredDocs = request.requiredDocuments || [];
    const uploadedDocs = request.uploadedDocuments || [];
    
    if (requiredDocs.length === 0) {
      return { status: "No Requirements", color: "default" };
    }
    
    if (uploadedDocs.length === 0) {
      return { status: "Pending", color: "error" };
    }
    
    // Check if all required documents are uploaded
    const uploadedDocTypes = uploadedDocs.map(doc => doc.documentType).filter(Boolean);
    const missingDocs = requiredDocs.filter(reqDoc => !uploadedDocTypes.includes(reqDoc));
    
    if (missingDocs.length === 0) {
      // All documents uploaded, check if all are approved
      const allApproved = uploadedDocs.every(doc => doc.status === 'Approved');
      const hasRejected = uploadedDocs.some(doc => doc.status === 'Rejected');
      
      if (hasRejected) {
        return { status: "Action Required", color: "warning" };
      } else if (allApproved) {
        return { status: "Completed", color: "success" };
      } else {
        return { status: "Under Review", color: "info" };
      }
    } else {
      // Some documents are missing
      return { status: "In Progress", color: "primary" };
    }
  };

  useEffect(() => {
    const fetchOnboardingRequests = async () => {
      try {
       const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
        if (!API_BASE_URL) {
          //console.error("API base URL is undefined");
          setSnackbar({
            open: true,
            message: "API configuration error. Please check your environment settings.",
            severity: "error",
          });
          setLoading(false);
          return;
        }
        
        const response = await axios.get(`${API_BASE_URL}/api/onboarding`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
          
            }
          }
        );
        
        const requests = response.data?.data || response.data || [];
        
    
        if (!Array.isArray(requests)) {
          //console.error("Unexpected response format:", requests);
          setSnackbar({
            open: true,
            message: "Received invalid data format from server",
            severity: "error",
          });
          setLoading(false);
          return;
        }
        
        const formattedRequests = requests.map(request => {
      
          let parsedRequiredDocs = [];
          try {
            parsedRequiredDocs = Array.isArray(request.requiredDocuments) 
              ? request.requiredDocuments 
              : (request.requiredDocuments ? JSON.parse(request.requiredDocuments) : []);
          } catch (parseError) {
            console.warn("Failed to parse requiredDocuments:", parseError);
            parsedRequiredDocs = [];
          }
          
          return {
            ...request,
            uploadedDocuments: request.documents || [], 
            requiredDocuments: parsedRequiredDocs
          };
        });
        
        setOnboardingRequests(formattedRequests);
        setLoading(false);
      } catch (error) {
        //console.error("Error fetching onboarding requests:", error);
    
        let errorMessage = "Failed to load onboarding requests";
        if (error.response) {
    
          errorMessage += `: ${error.response.status} - ${error.response.data?.message || error.response.statusText}`;
          //console.error("Server error details:", error.response.data);
        } else if (error.request) {
    
          errorMessage += ": No response received from server";
        } else {
        
          errorMessage += `: ${error.message}`;
        }
        
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
        setLoading(false);
      }
    };
    
    fetchOnboardingRequests();
   
    const interval = setInterval(fetchOnboardingRequests, 30000);
    
    return () => clearInterval(interval);
    
  }, []);

  const handleViewDetails = (request) => {
    setSelectedRequest(request);
    setOpenViewDialog(true);
  };

  const handleEditRequest = (request) => {
    setSelectedRequest(request);
  
    const standardValues = ["document-verification", "training", "induction", "it-setup", "complete-onboarding"];
    const isCustom = request.onboardingProcess && !standardValues.includes(request.onboardingProcess);

    setEditedRequest({
      ...request,
      onboardingProcess: isCustom ? "custom" : request.onboardingProcess,
      requiredDocuments: Array.isArray(request.requiredDocuments) 
        ? [...request.requiredDocuments] 
        : (request.requiredDocuments ? JSON.parse(request.requiredDocuments) : [])
    });
    setCustomProcessName(isCustom ? request.onboardingProcess : "");
    setIsCustomProcess(isCustom);
    setOpenEditDialog(true);
  };

  const handleSaveEdit = async () => {
    try {
        const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
      if (!editedRequest || !editedRequest.id) {
        throw new Error("Invalid request data");
      }
      
      if (editedRequest.onboardingProcess === "custom" && !customProcessName.trim()) {
        setSnackbar({ open: true, message: "Please enter a custom onboarding process name", severity: "error" });
        return;
      }
      
      const updateData = {
        employee_id: editedRequest.employee_id,
        candidateName: editedRequest.candidateName,
        candidateEmail: editedRequest.candidateEmail,
        onboardingProcess: editedRequest.onboardingProcess === "custom" ? customProcessName.trim() : editedRequest.onboardingProcess,
        processDetails: editedRequest.processDetails,
        requiredDocuments: editedRequest.requiredDocuments,
        taskCompletionDate: editedRequest.taskCompletionDate,
        status: editedRequest.status
      };
      
      const response = await axios.put(`${API_BASE_URL}/api/onboarding/${editedRequest.id}`, updateData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
      
   
      if (editedRequest.candidateEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editedRequest.candidateEmail)) {
        try {
          await axios.post(`${API_BASE_URL}/api/notifications/email`, {
            to: editedRequest.candidateEmail,
            subject: "Your Onboarding Process Has Been Updated",
            content: `Dear ${editedRequest.candidateName},\n\nYour onboarding process has been updated. Please log in to the employee portal for the latest requirements by ${editedRequest.taskCompletionDate}.\n\nRegards,\nHR Team`
          });
        } catch (emailError) {
          //console.error("Error sending email notification:", emailError);
       
          setSnackbar({
            open: true,
            message: "Onboarding request updated successfully, but email notification failed to send.",
            severity: "warning",
          });
        }
      }
    
      try {
          const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
        const fetchResponse = await axios.get(`${API_BASE_URL}/api/onboarding`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            
            }
          }
        );
        
   
        const requests = fetchResponse.data.data ? fetchResponse.data.data : fetchResponse.data;
        
        const formattedRequests = requests.map(request => ({
          ...request,
          uploadedDocuments: request.documents || [], 
       
          requiredDocuments: Array.isArray(request.requiredDocuments) 
            ? request.requiredDocuments 
            : (request.requiredDocuments ? JSON.parse(request.requiredDocuments) : [])
        }));
        
        setOnboardingRequests(formattedRequests);
      } catch (fetchError) {
        //console.error("Error refreshing onboarding requests:", fetchError);
    
        setOnboardingRequests(prev => 
          prev.map(req => req.id === editedRequest.id ? {
            ...editedRequest,
            uploadedDocuments: editedRequest.uploadedDocuments || []
          } : req)
        );
      }
      
      setOpenEditDialog(false);
      setSnackbar({
        open: true,
        message: "Onboarding request updated successfully.",
        severity: "success",
      });
    } catch (error) {
      //console.error("Error updating onboarding request:", error);
      setSnackbar({
        open: true,
        message: "Failed to update onboarding request: " + (error.response?.data?.message || error.message),
        severity: "error",
      });
    }
  }

  const handleDocumentChange = (event) => {
    const {
      target: { value },
    } = event;
    setEditedRequest(prev => ({
      ...prev,
      requiredDocuments: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const handleDeleteRequest = async (id) => {
      const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
    if (!id) {
      setSnackbar({
        open: true,
        message: "Invalid request ID",
        severity: "error",
      });
      return;
    }
    
    if (window.confirm("Are you sure you want to delete this onboarding request?")) {
      try {
        await axios.delete(`${API_BASE_URL}/api/onboarding/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        
      
        setOnboardingRequests(current => current.filter(req => req.id !== id));
        
        setSnackbar({
          open: true,
          message: "Onboarding request deleted successfully.",
          severity: "success",
        });
      } catch (error) {
        //console.error("Error deleting onboarding request:", error);
        setSnackbar({
          open: true,
          message: "Failed to delete onboarding request: " + (error.response?.data?.message || error.message),
          severity: "error",
        });
      }
    }
  };

  const handleViewDocument = (documentPath) => {
   const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
    if (documentPath) {

      window.open(`${API_BASE_URL}/api/documents/${documentPath}/view`, '_blank',
        {
          headers: {
            Authorization: `Bearer ${token}`,
         
          }
        }
      );
    } else {
      setSnackbar({
        open: true,
        message: "Document path is not available",
        severity: "error",
      });
    }
  };

  const handleDownloadDocument = async (documentId, fileName) => {
    try {
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
      const response = await axios.get(
        `${API_BASE_URL}/api/documents/${documentId}/download`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName || 'document.pdf');
      
     
      document.body.appendChild(link);
      

      link.click();
      

      link.parentNode.removeChild(link);
      
      setSnackbar({
        open: true,
        message: "Document downloaded successfully",
        severity: "success",
      });
    } catch (error) {
      //console.error("Error downloading document:", error);
      setSnackbar({
        open: true,
        message: "Failed to download document. Please try again.",
        severity: "error",
      });
    }
  };
  

 
  const handleViewDocumentDetails = (document) => {
    setSelectedDocument(document);
    setViewDocumentDialogOpen(true);
  };

  const updateDocumentStatus = async (documentId, status) => {
    if (!documentId) {
      setSnackbar({
        open: true,
        message: "Invalid document ID",
        severity: "error",
      });
      return;
    }
    
    try {
        const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
      await axios.patch(`${API_BASE_URL}/api/documents/${documentId}/status`, { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      
 
      const requestWithDoc = onboardingRequests.find(req => 
        req.uploadedDocuments?.some(doc => doc.id === documentId)
      );
      
      if (requestWithDoc) {
        try {
            const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      setLoading(false);
      return;
    }
    const payloadToken = JSON.parse(atob(token.split('.')[1]));
    const company_id = payloadToken.company_id;
          const response = await axios.get(`${API_BASE_URL}/api/onboarding/${requestWithDoc.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
              }
            }
          );
          
          let updatedRequest;
          if (response.data.data) {
            updatedRequest = {
              ...response.data.data,
              uploadedDocuments: response.data.data.documents || [],
       
              requiredDocuments: Array.isArray(response.data.data.requiredDocuments) 
                ? response.data.data.requiredDocuments 
                : (response.data.data.requiredDocuments ? JSON.parse(response.data.data.requiredDocuments) : [])
            };
          } else {
            updatedRequest = {
              ...response.data,
              uploadedDocuments: response.data.documents || [],
       
              requiredDocuments: Array.isArray(response.data.requiredDocuments) 
                ? response.data.requiredDocuments 
                : (response.data.requiredDocuments ? JSON.parse(response.data.requiredDocuments) : [])
            };
          }
          
         
          setOnboardingRequests(current => 
            current.map(req => req.id === requestWithDoc.id ? updatedRequest : req)
          );
          

          if (selectedDocument && selectedDocument.id === documentId) {
            const updatedDoc = updatedRequest.uploadedDocuments.find(doc => doc.id === documentId);
            if (updatedDoc) {
              setSelectedDocument(updatedDoc);
            }
          }
          
     
          if (requestWithDoc.candidateEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(requestWithDoc.candidateEmail)) {
            try {
              const documentType = selectedDocument?.documentType 
                ? getDocumentLabel(selectedDocument.documentType) 
                : (selectedDocument?.documentName || 'Document');
              
              await axios.post(`${API_BASE_URL}/api/notifications/email`, {
                to: requestWithDoc.candidateEmail,
                subject: `Document Status Update: ${status}`,
                content: `Your ${documentType} has been marked as ${status}. ${status === 'Rejected' ? 'Please upload a new version.' : 'No further action is required.'}`
              });
            } catch (emailError) {
              //console.error("Error sending document status notification:", emailError);
       
            }
          }
          
        } catch (error) {
          //console.error("Error refreshing document data:", error);
       
          setOnboardingRequests(current => 
            current.map(req => {
              if (req.id === requestWithDoc.id) {
                return {
                  ...req,
                  uploadedDocuments: req.uploadedDocuments.map(doc => 
                    doc.id === documentId ? { ...doc, status } : doc
                  )
                };
              }
              return req;
            })
          );
          
        
          if (selectedDocument && selectedDocument.id === documentId) {
            setSelectedDocument({
              ...selectedDocument,
              status
            });
          }
        }
      }
      
      setSnackbar({
        open: true,
        message: `Document marked as ${status}`,
        severity: "success",
      });
    } catch (error) {
      //console.error("Error updating document status:", error);
      setSnackbar({
        open: true,
        message: 'Failed to update document status: ' + (error.response?.data?.message || error.message),
        severity: 'error',
      });
    }
  }


const getStatusChipColor = (status) => {
  switch ((status || '').toLowerCase()) { 
    case "completed":
      return "success";
    case "in progress":
      return "primary";
    case "pending":
      return "warning";
    case "rejected":
    case "action required":
      return "error";
    case "under review":
      return "info";
    default:
      return "default";
  }
};

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  
  const getDocumentLabel = (value) => {
    if (!value) return "Unknown Document";
    const doc = documentOptions.find(option => option.value === value);
    return doc ? doc.label : value;
  };

 
  const getProcessLabel = (value) => {
    if (!value) return "Unknown Process";
    const process = processOptions.find(option => option.value === value);
    return process ? process.label : value;
  };

  const formatDate = (dateString) => {
    try {
      return dateString ? new Date(dateString).toLocaleDateString() : 'N/A';
    } catch (error) {
      //console.error("Error formatting date:", error);
      return 'Invalid Date';
    }
  };

  return (
    <Container maxWidth="1500px" sx={{ py: 4 }}>
    <Paper elevation={3} sx={{ p: 4,  borderRadius: 2, // Rounded corners
  border: '2px solid',
  borderColor: 'grey.300', // Subtle professional border
  boxShadow: 4,  }}>
      <Typography variant="h4" gutterBottom  sx={{ fontWeight: "bold" }}>
        Onboarding List
      </Typography>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell><Typography variant="subtitle1" fontWeight="bold">Candidate Name</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold">Email</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold">Process Type</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold">Due Date</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold">Status</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold">Documents</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold">Actions</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {getPaginatedRequests().length > 0 ? (
    getPaginatedRequests().map((request) => {
      const statusInfo = calculateOnboardingStatus(request);
                  return (
                    <TableRow key={request.id} hover>
                      <TableCell>{request.candidateName || 'N/A'}</TableCell>
                      <TableCell>{request.candidateEmail || 'N/A'}</TableCell>
                      <TableCell>{getProcessLabel(request.onboardingProcess)}</TableCell>
                      <TableCell>{formatDate(request.taskCompletionDate)}</TableCell>
                      <TableCell>
                        <Chip 
                          label={statusInfo.status} 
                          color={statusInfo.color} 
                          size="small" 
                          variant="filled"
                        />
                      </TableCell>
                      <TableCell>
                        {request.uploadedDocuments && request.uploadedDocuments.length > 0 ? (
                          <Chip 
                            label={`${request.uploadedDocuments.length} uploaded`} 
                            color="info" 
                            size="small" 
                            onClick={() => handleViewDetails(request)}
                            sx={{ cursor: 'pointer' }}
                          />
                        ) : (
                          <Chip 
                            label="None" 
                            color="default" 
                            size="small" 
                            variant="outlined"
                          />
                        )}
                      </TableCell>
                      <TableCell>
                        <IconButton size="small" onClick={() => handleViewDetails(request)} title="View">
                          <VisibilityIcon fontSize="small" color="primary" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleEditRequest(request)} title="Edit">
                          <EditIcon fontSize="small" color="primary"/>
                        </IconButton>
                        <IconButton 
                          size="small" 
                          onClick={() => handleDeleteRequest(request.id)} 
                          title="Delete"
                        >
                          <DeleteIcon fontSize="small" color="error" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography variant="body1" sx={{ py: 2 }}>
                      No onboarding requests found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

<TablePagination
  rowsPerPageOptions={[5, 10, 25]}
  component="div"
  count={onboardingRequests.length}
  rowsPerPage={rowsPerPage}
  page={page}
  onPageChange={handleChangePage}
  onRowsPerPageChange={handleChangeRowsPerPage}
  sx={{
    borderTop: '1px solid rgba(224, 224, 224, 1)',
    '& .MuiTablePagination-toolbar': {
      paddingLeft: 2,
      paddingRight: 2,
    },
  }}
  />

     
      <Dialog open={openViewDialog} onClose={() => setOpenViewDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            Onboarding Request Details
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          {selectedRequest && (
            <Box>
              <Typography variant="h6" gutterBottom fontWeight="bold">Candidate Information</Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
                <Box sx={{ flex: 1, minWidth: "200px" }}>
                  <Typography variant="subtitle2">Name:</Typography>
                  <Typography variant="body1" gutterBottom>{selectedRequest.candidateName || 'N/A'}</Typography>
                </Box>
                <Box sx={{ flex: 1, minWidth: "200px" }}>
                  <Typography variant="subtitle2">Email:</Typography>
                  <Typography variant="body1" gutterBottom>{selectedRequest.candidateEmail || 'N/A'}</Typography>
                </Box>
              </Box>

              <Typography variant="h6" gutterBottom fontWeight="bold">Process Information</Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
                <Box sx={{ flex: 1, minWidth: "200px" }}>
                  <Typography variant="subtitle2">Process Type:</Typography>
                  <Typography variant="body1" gutterBottom>
                    {getProcessLabel(selectedRequest.onboardingProcess)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, minWidth: "200px" }}>
                  <Typography variant="subtitle2" >Due Date:</Typography>
                  <Typography variant="body1" gutterBottom>
                    {formatDate(selectedRequest.taskCompletionDate)}
                  </Typography>
                </Box>
         
              </Box>

              <Typography variant="subtitle2" >Process Details:</Typography>
              <Typography variant="body1" paragraph sx={{ mb: 2 }}>
                {selectedRequest.processDetails || 'No details provided'}
              </Typography>

              <Typography variant="h6" gutterBottom fontWeight="bold">Required Documents</Typography>
              {selectedRequest.requiredDocuments && selectedRequest.requiredDocuments.length > 0 ? (
                <List dense sx={{ bgcolor: '#f5f5f5', borderRadius: 1, mb: 2 }}>
                  {selectedRequest.requiredDocuments.map((doc, index) => (
                    <ListItem key={index}>
                      <ListItemText 
                        primary={getDocumentLabel(doc)} 
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography variant="body2" sx={{ fontStyle: 'italic', py: 1 }}>
                  No required documents specified.
                </Typography>
              )}

              <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 2 }}>HR Reference Attachments</Typography>
              {(() => {
                const hrAttachments = (selectedRequest.uploadedDocuments || []).filter(doc => doc.documentType === 'onboarding-attachment' || doc.uploadedBy === 'HR');
                return hrAttachments.length > 0 ? (
                  <List dense sx={{ bgcolor: '#f9f9f9', borderRadius: 1, mb: 2 }}>
                    {hrAttachments.map((doc) => (
                      <ListItem
                        key={doc.id || doc._id}
                        secondaryAction={
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            startIcon={<DownloadIcon />}
                            onClick={() => handleDownloadDocument(
                              doc.id || doc._id, 
                              doc.documentName || 'attachment.pdf'
                            )}
                            disabled={!doc.documentPath}
                            sx={{ borderRadius: 1 }}
                          >
                            Download
                          </Button>
                        }
                      >
                        <ListItemText
                          primary={doc.documentName || 'Reference Document'}
                          secondary="Uploaded by HR"
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" sx={{ fontStyle: 'italic', py: 1, mb: 2, color: 'text.secondary' }}>
                    No reference templates or instructions attached.
                  </Typography>
                );
              })()}

              <Typography variant="h6" gutterBottom fontWeight="bold">Candidate Uploaded Documents</Typography>
              <Box sx={{ mb: 2, p: 1.5, bgcolor: '#f5f5f5', borderRadius: 1, borderLeft: '4px solid #757575', display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <InfoIcon fontSize="small" color="action" sx={{ mt: 0.2 }} />
                <Typography variant="body2" color="text.secondary">
                  To approve, reject, or update these documents, click the <strong>Review</strong> button at the bottom of this window.
                </Typography>
              </Box>
              {(() => {
                const candidateDocs = (selectedRequest.uploadedDocuments || []).filter(doc => doc.documentType !== 'onboarding-attachment' && doc.uploadedBy !== 'HR');
                return candidateDocs.length > 0 ? (
                  <List>
                    {candidateDocs.map((doc) => (
                      <ListItem
                        key={doc.id || doc._id}
                        secondaryAction={
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              startIcon={<DownloadIcon />}
                              onClick={() => handleDownloadDocument(
                                doc.id || doc._id, 
                                `${doc.documentType || 'document'}_${selectedRequest.candidateName || 'candidate'}.pdf`
                              )}
                              disabled={!doc.documentPath}
                              sx={{ borderRadius: 1 }}
                            >
                              Download
                            </Button>
                          </Box>
                        }
                      >
                        <ListItemText
                          primary={doc.documentName || getDocumentLabel(doc.documentType) || 'Unnamed Document'}
                          secondary={
                            <React.Fragment>
                              <Typography component="span" variant="body2" color="text.primary">
                                {doc.documentType && getDocumentLabel(doc.documentType)}
                              </Typography>
                              {" — "}
                              <Chip 
                                label={doc.status || 'Pending'} 
                                color={getStatusChipColor(doc.status)} 
                                size="small" 
                              />
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" sx={{ fontStyle: 'italic', py: 1, color: 'text.secondary' }}>
                    No documents uploaded by candidate yet.
                  </Typography>
                );
              })()}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
          {selectedRequest && (
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => {
                setOpenViewDialog(false);
                handleEditRequest(selectedRequest);
              }}
            >
              Review
            </Button>
          )}
        </DialogActions>
      </Dialog>

    
      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Edit Onboarding Request
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          {editedRequest && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                <TextField
                  label="Candidate Name"
                  value={editedRequest.candidateName || ''}
                  onChange={(e) => setEditedRequest({ ...editedRequest, candidateName: e.target.value })}
                  fullWidth
                  sx={{ flex: 1, minWidth: "200px" }}
                />
                <TextField
                  label="Candidate Email"
                  value={editedRequest.candidateEmail || ''}
                  onChange={(e) => setEditedRequest({ ...editedRequest, candidateEmail: e.target.value })}
                  fullWidth
                  sx={{ flex: 1, minWidth: "200px" }}
                />
              </Box>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                <FormControl fullWidth sx={{ flex: 1, minWidth: "200px" }}>
                  <InputLabel>Process Type</InputLabel>
                  <Select
                    value={editedRequest.onboardingProcess || ''}
                    onChange={(e) => {
                      const val = e.target.value;
                      setEditedRequest({ ...editedRequest, onboardingProcess: val });
                      if (val === "custom") {
                        setIsCustomProcess(true);
                      } else {
                        setIsCustomProcess(false);
                        setCustomProcessName("");
                      }
                    }}
                    label="Process Type"
                  >
                    {processOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                    <MenuItem value="custom">Other (Custom)</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Due Date"
                  type="date"
                  value={editedRequest.taskCompletionDate ? new Date(new Date(editedRequest.taskCompletionDate).getTime() - new Date(editedRequest.taskCompletionDate).getTimezoneOffset() * 60000).toISOString().split('T')[0] : ''}
                  onChange={(e) => setEditedRequest({ ...editedRequest, taskCompletionDate: e.target.value })}
                  fullWidth
                  sx={{ flex: 1, minWidth: "200px" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>

              {isCustomProcess && (
                <TextField
                  label="Custom Onboarding Process"
                  value={customProcessName}
                  onChange={(e) => setCustomProcessName(e.target.value)}
                  fullWidth
                  required
                  placeholder="Enter custom onboarding process name"
                />
              )}

              <TextField
                label="Process Details"
                value={editedRequest.processDetails || ''}
                onChange={(e) => setEditedRequest({ ...editedRequest, processDetails: e.target.value })}
                fullWidth
                multiline
                rows={4}
              />

              <FormControl fullWidth>
                <InputLabel>Required Documents</InputLabel>
                <Select
                  multiple
                  value={editedRequest.requiredDocuments || []}
                  onChange={handleDocumentChange}
                  label="Required Documents"
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={getDocumentLabel(value)} />
                      ))}
                    </Box>
                  )}
                >
                 {documentOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

            
              <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 2 }}>HR Reference Attachments</Typography>
              {(() => {
                const editHrAttachments = (editedRequest.uploadedDocuments || []).filter(doc => doc.documentType === 'onboarding-attachment' || doc.uploadedBy === 'HR');
                return editHrAttachments.length > 0 ? (
                  <List dense sx={{ bgcolor: '#f9f9f9', borderRadius: 1, mb: 2 }}>
                    {editHrAttachments.map((doc) => (
                      <ListItem
                        key={doc.id || doc._id}
                        secondaryAction={
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            startIcon={<DownloadIcon />}
                            onClick={() => handleDownloadDocument(
                              doc.id || doc._id, 
                              doc.documentName || 'attachment.pdf'
                            )}
                            disabled={!doc.documentPath}
                            sx={{ borderRadius: 1 }}
                          >
                            Download
                          </Button>
                        }
                      >
                        <ListItemText
                          primary={doc.documentName || 'Reference Document'}
                          secondary="Uploaded by HR"
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" sx={{ fontStyle: 'italic', py: 1, mb: 2, color: 'text.secondary' }}>
                    No reference templates or instructions attached.
                  </Typography>
                );
              })()}

              <Typography variant="h6" gutterBottom fontWeight="bold">Candidate Uploaded Documents</Typography>
              <Box sx={{ mb: 2, p: 1.5, bgcolor: '#e3f2fd', borderRadius: 1, borderLeft: '4px solid #1976d2', display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <InfoIcon fontSize="small" color="primary" sx={{ mt: 0.2 }} />
                <Box>
                  <Typography variant="body2" color="text.primary" sx={{ mb: 0.5 }}>
                    Please review the candidate's uploaded proofs. Click <strong>Approve</strong> if the document is valid, or <strong>Reject</strong> to ask the candidate to re-upload.
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                    Note: After making your document decisions, you must click the "SAVE CHANGES" button below to save your actions.
                  </Typography>
                </Box>
              </Box>
              {(() => {
                const editCandidateDocs = (editedRequest.uploadedDocuments || []).filter(doc => doc.documentType !== 'onboarding-attachment' && doc.uploadedBy !== 'HR');
                return editCandidateDocs.length > 0 ? (
                  <List sx={{ bgcolor: '#f5f5f5', borderRadius: 1 }}>
                    {editCandidateDocs.map((doc) => (
                      <ListItem
                        key={doc.id || doc._id}
                        secondaryAction={
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            {doc.status !== 'Approved' && doc.status !== 'Rejected' && (
                              <>
                                <Button
                                  variant="outlined"
                                  color="success"
                                  size="small"
                                  onClick={() => updateDocumentStatus(doc.id || doc._id, 'Approved')}
                                  sx={{ borderRadius: 1 }}
                                >
                                  Approve
                                </Button>
                                <Button
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  onClick={() => updateDocumentStatus(doc.id || doc._id, 'Rejected')}
                                  sx={{ borderRadius: 1 }}
                                >
                                  Reject
                                </Button>
                              </>
                            )}
                            
                          </Box>
                        }
                      >
                        <ListItemText
                          primary={doc.documentName || getDocumentLabel(doc.documentType) || 'Unnamed Document'}
                          secondary={
                            <React.Fragment>
                              <Typography component="span" variant="body2" color="text.primary">
                                {doc.documentType && getDocumentLabel(doc.documentType)}
                              </Typography>
                              {" — "}
                              <Chip 
                                label={doc.status || 'Pending'} 
                                color={getStatusChipColor(doc.status)} 
                                size="small" 
                              />
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" sx={{ fontStyle: 'italic', py: 1, color: 'text.secondary' }}>
                    No documents uploaded by candidate yet.
                  </Typography>
                );
              })()}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSaveEdit}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

    
      <Dialog open={viewDocumentDialogOpen} onClose={() => setViewDocumentDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Document Details
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          {selectedDocument && (
            <Box>
              <Typography variant="h6" gutterBottom>
                {selectedDocument.documentName || getDocumentLabel(selectedDocument.documentType) || 'Unnamed Document'}
              </Typography>
              
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
                <Box sx={{ flex: 1, minWidth: "200px" }}>
                  <Typography variant="subtitle2">Document Type:</Typography>
                  <Typography variant="body1" gutterBottom>
                    {selectedDocument.documentType ? getDocumentLabel(selectedDocument.documentType) : 'Not specified'}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, minWidth: "200px" }}>
                  <Typography variant="subtitle2">Status:</Typography>
                  <Chip 
                    label={selectedDocument.status || 'Pending'} 
                    color={getStatusChipColor(selectedDocument.status)} 
                    size="small" 
                  />
                </Box>
                <Box sx={{ flex: 1, minWidth: "200px" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<DownloadIcon />}
                  onClick={() => handleDownloadDocument(
                    selectedDocument.id || selectedDocument._id, 
                    selectedDocument.documentName || `${selectedDocument.documentType || 'document'}.pdf`
                  )}
                  disabled={!selectedDocument.documentPath}
                  sx={{ mx: 1 }}
                >
                  Download
                </Button>
                </Box>
               
              </Box>
            
              
              <Box sx={{ mt: 3, borderTop: '1px solid #e0e0e0', pt: 2 }}>
                <Typography variant="subtitle1" gutterBottom>Update Document Status:</Typography>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 1 }}>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => {
                      updateDocumentStatus(selectedDocument.id || selectedDocument._id, 'Approved');
                      setViewDocumentDialogOpen(false);
                    }}
                    disabled={selectedDocument.status === 'Approved'}
                  >
                    Approve Document
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                      updateDocumentStatus(selectedDocument.id || selectedDocument._id, 'Rejected');
                      setViewDocumentDialogOpen(false);
                    }}
                    disabled={selectedDocument.status === 'Rejected'}
                  >
                    Reject Document
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDocumentDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

     
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity} 
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
  </Paper>
  </Container>
  );
};

export default OnboardingListPage;